/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Evgeniy Naumov
 * @version 1.25.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors } from '../../../../theme';
import { IAttrStyled } from '../../../../types/globalTypes';

export const SuperSearchInputStyled = styled.div.attrs({
    className: 'super-search__input-container',
})`
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 100%;
    padding-right: 12px;
    & .input__container {
        & .input__input-block {
            border: none;
            padding-left: 0;
            padding-right: 0;
            margin-left: 8px;
        }
        & .input__input-icon {
            width: 32px;
            right: 0;
        }
    };
`;
export const SuperSearchStubStyled = styled.div.attrs({
    className: 'super-search__stub-container',
})`
    height: 100%;
    flex-basis: 165px;
`;
export const SuperSearchContainerStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `super-search__container ${className || ''}`,
}))<IAttrStyled>`
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    transition: width 0.5s ease-in-out;
    background-color: ${colors.superSearchBgColor};
    &.closed {
        width: 56px;
        & ${SuperSearchInputStyled} {
            width: 0;
        }
    };
    &.opened {
        width: 100%;

        .super-search__open-icon {
            cursor: default;
            outline: none;
        }
    };
`;
export const SuperSearchIconStyled = styled.img.attrs({
    'className': 'super-search__open-icon',
    'data-icon': 'iconSearchHeader',
    'tabIndex': 0,
})`
    width: 32px;
    height: 32px;
    display: block;
    position: relative;
    top: 50%;
    margin-top: -16px;
    background-color: ${colors.superSearchBgColor};
    cursor: pointer;
    z-index: 5;
`;

export const SuperSearchIconContainerStyled = styled.div.attrs({
    className: 'super-search__icon-container',
})`
    position: relative;
    z-index: 10;
`;
